import { Button, Card, Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, Row, TimePicker } from 'antd'
import InfoTooltip from '../../../../elements/InfoTooltip'
import MaterialDetails from '../../../../elements/MaterialDetails'
import ProductSelection from '../../../../elements/ProductSelection'
import LocationSelect from '../../../../elements/Select/Location'
import UOM from '../../../../elements/Select/UOM'
import ShippingDetails from '../../../../elements/ShippingDetails'
import Taxes from '../../../../elements/Taxes'
import { get } from 'lodash'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
} from '../../../../modules/FormItems'
import { dateVal, strVal } from '../../../../modules/Utils'
import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'

const { TextArea } = Input

function OrderLineFormSubCont(props) {
  const {
    service,
    onChangeService,
    onChangeVehicles,
    disabledStartDate,
    disabledEndDate,
    onStartChange,
    onEndChange,
    handleStartOpenChange,
    handleEndOpenChange,
    onChangeQuoteLine,
    QuoteLinesSelect,
    VehiclesSelect,
    ClientBudgetsSelect,

    endOpen,
    price,
    days,
    line,
    category,
    ServicesSelectCmp,
    addDestination,
    removeDestination,
    handleLocationChange,
    onChangeProductCategory,
    onChangeProductGroup,
    onChangeDestinations,
    order,
    HeaderLinesSelect,
  } = props

  let destinations = get(line, 'booking.destinations', [])
  const { getFieldDecorator, getFieldsValue, getFieldValue, setFieldsValue, resetFields } = props.form

  const rate = getFieldValue('rate') || 0
  const unit = getFieldValue('unit') || 0
  const [total, setTotal] = useState(rate * unit)

  React.useEffect(() => {
    setTotal(rate * unit)

    setFieldsValue({
      'tax.rate': (rate * unit * getFieldValue('tax.percentage')) / 100.0,
    })
  }, [rate, unit])

  const isShippable = getFieldValue('isShippable') || false
  // useEffect(() => {
  // }, [rate, unit])

  console.log(1123, order)

  return (
    <Form>
      {!get(order, 'isOnlineOrder', false) && !get(order, 'isSalesConfirmation', false) && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Is Header Line'}>
              {getFieldDecorator('isHeader', {
                initialValue: get(line, 'isHeader'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
          {!getFieldValue('isHeader') ? (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Header Line'}>
                {getFieldDecorator('parentId', {
                  initialValue: get(line, 'parentId'),
                })(<HeaderLinesSelect keyAtr={'_id'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
          ) : (
            ' '
          )}
        </Row>
      )}
      {!getFieldValue('isHeader') ? (
        <>
          <Row>
            {!get(order, 'isOnlineOrder', false) && !get(order, 'isSalesConfirmation', false) && (
              <Row>
                <Col span={24}>
                  <Form.Item {...fullWidthFormItemLayout} label={'Quote Line'}>
                    {getFieldDecorator('quoteLine._id', {
                      initialValue: get(line, 'quoteLine._id'),
                    })(
                      <QuoteLinesSelect
                        style={{ width: '80%' }}
                        placeholder={'Quote Line'}
                        keyAtr={'_id'}
                        valueAtr={'display'}
                        onChange={onChangeQuoteLine}
                      />
                    )}
                    <Link target={'_blank'} to={`/client/quotes/${strVal(props, 'order.quote._key')}/update`}>
                      <Icon style={{ marginLeft: 5 }} type="fullscreen" />
                    </Link>
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row>
              <h3>Client Order Details</h3>
              <Col span={6}>
                <Form.Item {...defaultFormItemLayout} label={'Line No.'}>
                  {getFieldDecorator('no', {
                    initialValue: get(line, 'no'),
                    rules: [{ required: true, message: 'Please Select a No!' }],
                  })(<Input placeholder={'Line No'} style={{ width: '80%' }} />)}
                </Form.Item>
              </Col>
              <Col span={18}>
                <Form.Item {...defaultFormItemLayout} label={'Line Name'}>
                  {getFieldDecorator('name', {
                    initialValue: get(line, 'name'),
                    rules: rules.input,
                  })(<Input placeholder={'Line Name'} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={16}>
                <Form.Item {...fullWidthFormItemLayout} label={'Description'}>
                  {getFieldDecorator('description', {
                    initialValue: get(line, 'description'),
                  })(<TextArea placeholder={'Description'} />)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label="Delivery Days">
                  {getFieldDecorator('delivery.no', {
                    initialValue: get(line, 'delivery.no') || get(order, 'delivery.no'),
                    rules: rules.select,
                  })(<InputNumber placeholder={'Delivery Days'} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <h3>Rate Details</h3>
              <Taxes
                doc={{
                  ...line,
                  ...{
                    taxType: get(order, 'taxType'),
                    tax: get(order, 'tax'),
                  },
                }}
                {...{
                  getFieldDecorator,
                  getFieldValue,
                  setFieldsValue,
                  resetFields,
                  type: 'saleLines',
                  price: rate,
                }}
              />
            </Row>
            <Row>
              <Col span={8}>
                <Form.Item {...threeFormItemLayout} label={'Quantity'}>
                  {getFieldDecorator('unit', {
                    initialValue: get(line, 'unit') || 1,
                    rules: [{ required: true, message: 'Please Select a unit!' }],
                  })(
                    <Input
                      type="number"
                      style={{ width: '80%' }}
                      addonAfter={
                        <span>
                          {get(price, 'uom.name') || get(line, 'uom.code') || get(line, 'productLine.uom.key')}
                        </span>
                      }
                      placeholder={'Quantity'}
                      // onChange={onChangeUnit}
                      // onChange={onChangeRateUnit}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...threeFormItemLayout} label="UOM">
                  {getFieldDecorator('uom.code', {
                    initialValue: get(line, 'uom.code'),
                    rules: rules.select,
                  })(<UOM style={{ width: '80%' }} />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...threeFormItemLayout} label={'Rate'}>
                  {getFieldDecorator('rate', {
                    initialValue: get(line, 'rate'),
                    rules: rules.input,
                  })(<InputNumber style={{ width: '80%' }} placeholder={'Rate'} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'Is Shippable'}>
                  {getFieldDecorator('isShippable', {
                    initialValue: get(line, 'isShippable'),
                    valuePropName: 'checked',
                  })(<Checkbox value={get(line, 'isShippable')} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'TOTAL (NET)'}>
                  <InputNumber style={{ width: '100%' }} disabled={true} value={total} placeholder={'Total'} />
                </Form.Item>
              </Col>
            </Row>
            {/*// CLIENT MATERIAL DETAILS*/}

            <MaterialDetails
              line={line}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'Order',
              }}
            />

            <ShippingDetails
              line={line}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'Order',
                required: isShippable,
              }}
            />

            <ProductSelection
              {...{
                doc: line,
                getFieldDecorator,
                getFieldsValue,
                getFieldValue,
                setFieldsValue,
                resetFields,
                company: get(order, 'company._id'),
                onChangeProductCategory,
                onChangeProductGroup,
              }}
            />

            {!props.form.getFieldValue('isProduct') && (
              <Fragment>
                <Col span={12}>
                  <Form.Item
                    {...defaultFormItemLayout}
                    label={<InfoTooltip value={'Service'} title={'Select a contract with rates'} />}>
                    {getFieldDecorator('booking.ref.key', {
                      initialValue: get(line, 'booking.ref.key'),
                      rules: rules.select,
                    })(
                      <ServicesSelectCmp
                        placeholder={'Services'}
                        keyAtr={'key'}
                        valueAtr={'name'}
                        onChange={onChangeService}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Rate'}>
                    {getFieldDecorator('rate', {
                      initialValue: get(line, 'rate'),
                    })(<InputNumber disabled={true} style={{ width: '100%' }} placeholder={'Rate'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Description'}>
                    <span>{strVal(service, 'product.description')}</span>
                  </Form.Item>
                </Col>
              </Fragment>
            )}
          </Row>
          {category === 'vehicles' && (
            <Row>
              <Row style={{ marginLeft: 10 }}>
                <h3>Pick up / Drop off</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Pick Up'}>
                    <Col span={12}>
                      {getFieldDecorator('booking.pickup.date', {
                        rules: [
                          {
                            required: true,
                            message: 'Please Select a Pick Up!',
                          },
                        ],
                        initialValue: dateVal(line, 'booking.pickup.date'),
                      })(
                        <DatePicker
                          style={{ width: '100%' }}
                          disabledDate={disabledStartDate}
                          onChange={onStartChange}
                          onOpenChange={handleStartOpenChange}
                          placeholder="Pick up Date"
                          format="ddd YYYY-MM-DD"
                        />
                      )}
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        {getFieldDecorator('booking.pickup.time', {
                          rules: [
                            {
                              required: true,
                              message: 'Please Select a pickup time!',
                            },
                          ],

                          initialValue: dateVal(line, 'booking.pickup.time'),
                        })(<TimePicker format="HH:mm" style={{ marginLeft: 10 }} placeholder="Pick up Time" />)}
                      </Form.Item>
                    </Col>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Drop off'}>
                    <Col span={12}>
                      {getFieldDecorator('booking.dropoff.date', {
                        rules: [
                          {
                            required: true,
                            message: 'Please Select a Drop off date!',
                          },
                        ],
                        initialValue: dateVal(line, 'booking.dropoff.date'),
                      })(
                        <DatePicker
                          style={{ width: '100%' }}
                          disabledDate={disabledEndDate}
                          onChange={onEndChange}
                          open={endOpen}
                          onOpenChange={handleEndOpenChange}
                          placeholder="Drop off Date"
                          format="ddd YYYY-MM-DD"
                        />
                      )}
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        {getFieldDecorator('booking.dropoff.time', {
                          rules: [
                            {
                              required: true,
                              message: 'Please Select a drop off time!',
                            },
                          ],
                          initialValue: dateVal(line, 'booking.dropoff.time'),
                        })(<TimePicker format="HH:mm" style={{ marginLeft: 10 }} placeholder="Drop off Time" />)}
                      </Form.Item>
                    </Col>
                  </Form.Item>
                </Col>
              </Row>
              <h3>Vehicle</h3>
              <Row>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Vehicle'}>
                    {getFieldDecorator('booking.vehicle._id', {
                      initialValue: get(line, 'booking.vehicle._id'),
                      rules: [{ required: true, message: 'Please Select a Vehicle!' }],
                    })(
                      <VehiclesSelect
                        placeholder={'Vehicles'}
                        keyAtr={'_id'}
                        valueAtr={'description'}
                        onChange={onChangeVehicles}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Plate No'}>
                    {getFieldDecorator('booking.vehicle.plate', {
                      initialValue: get(line, 'booking.vehicle.plate'),
                    })(<Input placeholder={'Plate No'} />)}
                  </Form.Item>
                </Col>
              </Row>
              <h3>Salik</h3>
              <Row>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Tag No'}>
                    {getFieldDecorator('booking.salik.tag', {
                      initialValue: get(line, 'booking.salik.tag'),
                    })(<Input placeholder={'Tag No'} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
          )}
          {category === 'commuter-services' && (
            <Row>
              <Row style={{ marginLeft: 10 }}>
                <h3>Start / End Date</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Start'}>
                    {getFieldDecorator('booking.pickup.date', {
                      rules: rules.select,
                      initialValue: dateVal(line, 'booking.pickup.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledStartDate}
                        onChange={onStartChange}
                        onOpenChange={handleStartOpenChange}
                        placeholder="Start Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'End'}>
                    {getFieldDecorator('booking.dropoff.date', {
                      rules: [
                        {
                          required: true,
                          message: 'Please Select a End date!',
                        },
                      ],
                      initialValue: dateVal(line, 'booking.dropoff.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledEndDate}
                        onChange={onEndChange}
                        open={endOpen}
                        onOpenChange={handleEndOpenChange}
                        placeholder="End Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
          )}
          {category === 'chauffeur-services' && (
            <Row>
              <Row>
                <Col offset={2} span={9}>
                  <Card title={'Pickup details'}>
                    <Form.Item label={'Date / (Time - optional)'}>
                      {getFieldDecorator('booking.pickup.date', {
                        initialValue: dateVal(line, 'booking.pickup.date'),
                        rules: [{ required: true, message: 'Please Select a Date!' }],
                      })(<DatePicker style={{ width: '100%' }} placeholder="Pick up Date" format="ddd YYYY-MM-DD" />)}
                      {getFieldDecorator('booking.pickup.time', {
                        initialValue: dateVal(line, 'booking.pickup.time'),
                      })(<TimePicker format="HH:mm" style={{ marginLeft: 10 }} placeholder="Pick up Time" />)}
                    </Form.Item>
                    <Form.Item label={'Notes'}>
                      {getFieldDecorator('booking.pickup.notes', {
                        initialValue: get(line, 'booking.pickup.notes'),
                      })(<Input placeholder="Notes" />)}
                    </Form.Item>

                    <Form.Item label={'Location'}>
                      {getFieldDecorator('booking.pickup.location', {
                        initialValue: get(line, 'booking.pickup.location'),
                        rules: [
                          {
                            required: true,
                            message: 'Location Address Can`\t be Empty.',
                          },
                        ],
                      })(
                        <LocationSelect
                          onChange={(v) => {
                            props.form.setFieldsValue({
                              'booking.pickup.label': v.address,
                            })
                            handleLocationChange('booking.pickup.location', v)
                          }}
                        />
                      )}
                    </Form.Item>
                    <Form.Item label={'Display Address'}>
                      {getFieldDecorator('booking.pickup.label', {
                        initialValue: get(line, 'booking.pickup.label'),
                      })(<Input placeholder={'Display Address'} />)}
                    </Form.Item>
                  </Card>
                </Col>
                <Col offset={2} span={9}>
                  <Card title={'Drop off details'}>
                    <Form.Item label={'Notes'}>
                      {getFieldDecorator('booking.dropoff.notes', {
                        initialValue: get(line, 'booking.dropoff.notes'),
                      })(<Input placeholder="Notes" />)}
                    </Form.Item>

                    <Form.Item label={'Location'}>
                      {getFieldDecorator('booking.dropoff.location', {
                        initialValue: get(line, 'booking.dropoff.location'),
                        rules: [
                          {
                            required: true,
                            message: 'Location  Can`\t be Empty.',
                          },
                        ],
                      })(
                        <LocationSelect
                          onChange={(v) => {
                            props.form.setFieldsValue({
                              'booking.dropoff.label': v.address,
                            })
                            handleLocationChange('booking.dropoff.location', v)
                          }}
                        />
                      )}
                    </Form.Item>
                    <Form.Item label={'Display Address'}>
                      {getFieldDecorator('booking.dropoff.label', {
                        initialValue: get(line, 'booking.dropoff.label'),
                      })(<Input placeholder={'Display Address'} />)}
                    </Form.Item>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col style={{ marginTop: 10 }} offset={2} span={20}>
                  <Card
                    title={
                      <InfoTooltip value={'Destinations'} title={'Locations of other trips within this booking.'} />
                    }
                    extra={<Button type="primary" shape="circle" icon="plus" onClick={addDestination} />}>
                    {destinations.map((d) => (
                      <Fragment>
                        <Form.Item {...defaultFormItemLayout} label={'Destination'}>
                          {getFieldDecorator('booking.destinations.' + d.key, {
                            initialValue: d.location,
                            rules: [
                              {
                                required: true,
                                message: `Destination Can't be Empty.`,
                              },
                            ],
                          })(
                            <LocationSelect
                              key={d.key}
                              style={{ width: '80%' }}
                              onChange={(v) => {
                                onChangeDestinations(d.key, v.address, 'label')
                                onChangeDestinations(d.key, v, 'location')
                              }}
                            />
                          )}
                        </Form.Item>
                        <Form.Item {...defaultFormItemLayout} label={'Display Address'}>
                          <Input
                            style={{ width: '80%' }}
                            placeholder={'Display Address'}
                            value={d.label}
                            onChange={(v) => onChangeDestinations(d.key, v.target.value, 'label')}
                          />
                          {
                            <Button
                              style={{ marginLeft: 10 }}
                              type="danger"
                              shape="circle"
                              icon="minus"
                              onClick={() => removeDestination(d.key)}
                            />
                          }
                        </Form.Item>
                      </Fragment>
                    ))}
                  </Card>
                </Col>
              </Row>
            </Row>
          )}
          {category === 'VD' && (
            <Row>
              <Row style={{ marginLeft: 10 }}>
                <h3>Booking Details</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Start'}>
                    {getFieldDecorator('booking.pickup.date', {
                      rules: [{ required: true, message: 'Please Select a Start!' }],
                      initialValue: dateVal(line, 'booking.pickup.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledStartDate}
                        onChange={onStartChange}
                        onOpenChange={handleStartOpenChange}
                        placeholder="Start Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'End'}>
                    {getFieldDecorator('booking.dropoff.date', {
                      initialValue: dateVal(line, 'booking.dropoff.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledEndDate}
                        onChange={onEndChange}
                        open={endOpen}
                        onOpenChange={handleEndOpenChange}
                        placeholder="End Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Days'}>
                    <span>{days}</span>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <h3>Vehicle</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Vehicle'}>
                    {getFieldDecorator('booking.vehicle.name', {
                      initialValue: get(line, 'booking.vehicle.name'),
                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Plate No'}>
                    {getFieldDecorator('booking.vehicle.plate', {
                      initialValue: get(line, 'booking.vehicle.plate'),
                    })(<Input placeholder={'Plate No'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Driver Name'}>
                    {getFieldDecorator('booking.vehicle.driver', {
                      initialValue: get(line, 'booking.vehicle.driver'),
                    })(<Input placeholder={'Driver Name'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Driver Phone'}>
                    {getFieldDecorator('booking.vehicle.driverPhone', {
                      initialValue: get(line, 'booking.vehicle.driverPhone'),
                    })(<Input placeholder={'Driver Phone'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Fuel Tag'}>
                    {getFieldDecorator('booking.vehicle.fuelTag', {
                      initialValue: get(line, 'booking.vehicle.fuelTag'),
                    })(<Input placeholder={'Fuel Tag'} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
          )}

          {['PM', 'PV', 'LB'].includes(category) && (
            <Row>
              <Row style={{ marginLeft: 10 }}>
                <h3>Booking Details</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Start'}>
                    {getFieldDecorator('booking.pickup.date', {
                      rules: [{ required: true, message: 'Please Select a Start!' }],
                      initialValue: dateVal(line, 'booking.pickup.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledStartDate}
                        onChange={onStartChange}
                        onOpenChange={handleStartOpenChange}
                        placeholder="Start Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'End'}>
                    {getFieldDecorator('booking.dropoff.date', {
                      initialValue: dateVal(line, 'booking.dropoff.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledEndDate}
                        onChange={onEndChange}
                        open={endOpen}
                        onOpenChange={handleEndOpenChange}
                        placeholder="End Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Days'}>
                    <span>{days}</span>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <h3>Vehicle</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Vehicle'}>
                    {getFieldDecorator('booking.vehicle.name', {
                      initialValue: get(line, 'booking.vehicle.name'),
                    })(<Input placeholder={'Vehicles'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Plate No'}>
                    {getFieldDecorator('booking.vehicle.plate', {
                      initialValue: get(line, 'booking.vehicle.plate'),
                    })(<Input placeholder={'Plate No'} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
          )}
          {category === 'VR' && (
            <Row>
              <Row style={{ marginLeft: 10 }}>
                <h3>Booking Details</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Start'}>
                    {getFieldDecorator('booking.pickup.date', {
                      rules: [{ required: true, message: 'Please Select a Start!' }],
                      initialValue: dateVal(line, 'booking.pickup.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledStartDate}
                        onChange={onStartChange}
                        onOpenChange={handleStartOpenChange}
                        placeholder="Start Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'End'}>
                    {getFieldDecorator('booking.dropoff.date', {
                      initialValue: dateVal(line, 'booking.dropoff.date'),
                    })(
                      <DatePicker
                        style={{ width: '100%' }}
                        disabledDate={disabledEndDate}
                        onChange={onEndChange}
                        open={endOpen}
                        onOpenChange={handleEndOpenChange}
                        placeholder="End Date"
                        format="ddd YYYY-MM-DD"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Days'}>
                    <span>{days}</span>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <h3>Vehicle</h3>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Vehicle'}>
                    {getFieldDecorator('booking.vehicle.name', {
                      initialValue: get(line, 'booking.vehicle.name'),
                    })(<Input placeholder={'Vehicles'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Plate No'}>
                    {getFieldDecorator('booking.vehicle.plate', {
                      initialValue: get(line, 'booking.vehicle.plate'),
                    })(<Input placeholder={'Plate No'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Fuel Tag'}>
                    {getFieldDecorator('booking.vehicle.fuelTag', {
                      initialValue: get(line, 'booking.vehicle.fuelTag'),
                    })(<Input placeholder={'Fuel Tag'} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={'Client Budget Line'}>
                    {getFieldDecorator('clientBudget._id', {
                      initialValue: get(line, 'clientBudget._id'),
                    })(<ClientBudgetsSelect />)}
                  </Form.Item>
                </Col>
              </Row>
            </Row>
          )}
        </>
      ) : (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Line No.'}>
              {getFieldDecorator('no', {
                initialValue: get(line, 'no'),
                rules: rules.input,
              })(<Input placeholder={'Line No.'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Line Name'}>
              {getFieldDecorator('name', {
                initialValue: get(line, 'name'),
                rules: rules.input,
              })(<Input placeholder={'Line Name'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Description'}>
              {getFieldDecorator('description', {
                initialValue: get(line, 'description'),
              })(<TextArea placeholder={'Description'} />)}
            </Form.Item>
          </Col>
        </Row>
      )}
    </Form>
  )
}

export default compose(Form.create())(OrderLineFormSubCont)
